var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","strokeWidth":"2.5"},[React.createElement("path",{"stroke":"#000","strokeMiterlimit":"10","d":"M1.59 8.61a9.95 9.95 0 1 1 1 7.55 9.95 9.95 0 0 1-1-7.55Z","key":0}),React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","d":"M11.19 5.65v5.84l3.6 2.22","key":1})]));
}

Clock.defaultProps = {"width":"22.38","height":"22.38","data-name":"Layer 1","viewBox":"0 0 22.38 22.38"};

module.exports = Clock;

Clock.default = Clock;
